import { fetchWithAuth } from '../utils/fetchWithAuth';
import { unwrapResponse as unwrap } from '../utils/unwrapResponse';

export interface ImpersonationCandidate {
  id: number;
  username: string;
  email: string;
  role: string;
}

export interface ImpersonationTarget {
  username: string;
  email: string;
  accountId: string | null;
  userId: string;
  role: string;
}

export interface StartImpersonationResult {
  impersonationToken: string;
  target: ImpersonationTarget;
}

export const impersonationApi = {
  /** Search active, impersonatable users by name/email (superadmin only). */
  searchUsers: async (query: string): Promise<ImpersonationCandidate[]> => {
    const res = await fetchWithAuth(`users/search?q=${encodeURIComponent(query)}`);
    return unwrap<ImpersonationCandidate[]>(res, 'Failed to search users');
  },

  /** Start impersonating a target user; returns the signed token + target identity. */
  start: async (targetUserId: number): Promise<StartImpersonationResult> => {
    const res = await fetchWithAuth('auth/impersonate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ targetUserId }),
    });
    return unwrap<StartImpersonationResult>(res, 'Failed to start impersonation');
  },
};
